import { useState } from "react";
import axios from "axios";
import LoadingSpinner from "../../components/LoadingSpinner";
import { ApiConnectionString } from "../../constants/ApiConntection";
import { useAuthContext } from "../../hooks/useAuthContext";
import { useNavigate } from "react-router-dom";

export default function CreateWebsite() {
  const [Name, setName] = useState("");
  const [Concept, setConcept] = useState("");
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const navi = useNavigate();

  const { user } = useAuthContext();

  const validate = () => {
    const e = {};
    if (!Name) e.Name = "Required";
    if (!Concept) e.Concept = "Required";
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      if (!validate()) return;

      const request = { Name, Concept };

      const response = await axios.post(`${ApiConnectionString}/api/website`, request, {
        headers: { Authorization: `bearer ${user.token}` },
      });

      if (response.status === 200) {
        navi(`/myonewebsite/${response.data.id}`);
      }
    } catch {
      // handle error if needed
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <div>
        <LoadingSpinner />
      </div>
    );
  }

  return (
    <div className="container py-4">
      <div className="row justify-content-center">
        <div className="col-md-8 col-lg-6">

          {/* Page Title */}
          <h1 className="mb-2">Website Details</h1>
          <p className="text-muted mb-4">
            Set up a new website in Border City Software.
            You can change anything later — this is just to help you organise your websites.
          </p>

          {/* FORM */}
          <form onSubmit={handleSubmit}>

            {/* Website Name */}
            <div className="mb-3">
              <label htmlFor="websiteName" className="form-label fw-semibold">
                Website name
              </label>
              <input
                type="text"
                id="websiteName"
                className="form-control"
                placeholder="eg. Helen's Yoga Site"
                value={Name}
                onChange={(e) => setName(e.target.value)}
                required
              />
              <div className="form-text">
                This name is <strong>only used inside your dashboard</strong> so you can tell your websites apart.
                It is <strong>not</strong> the public URL and visitors will not see it.
              </div>
            </div>

            {/* Concept */}
            <div className="mb-3">
              <label htmlFor="websiteConcept" className="form-label fw-semibold">
                Concept
              </label>
              <textarea
                id="websiteConcept"
                className="form-control"
                rows="4"
                placeholder="eg. A small site to promote my yoga classes, show a timetable and let people contact me."
                value={Concept}
                onChange={(e) => setConcept(e.target.value)}
                required
              />
              <div className="form-text">
                Describe what the website is for, who it’s aimed at and any key pages you think you'll need.
                This helps guide the editor when choosing layouts and sections.
              </div>
            </div>

            {/* Buttons */}
            <div className="d-flex gap-2 mt-4">
              <button type="submit" className="btn btn-primary">
                Submit Details
              </button>
              <button onClick={() => navi("/")} className="btn btn-outline-secondary">
                Cancel
              </button>
            </div>

          </form>

        </div>
      </div>
    </div>
  );
}
